import react, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { trackBtnClick } from "@/lib/helper";
import Div100vh from "react-div-100vh";
import PrimaryButton from "../common/buttons/PrimaryButton";
import bgBhai from "@/assets/images/bubbles.jpg";
import Header from "@/components/common/Header/header";

const landlordBenefits = [
  {
    title: "Get Advance Rent",
    description: "of the entire lease (Non-Refundable)",
    image: "/path-to-image-3.jpg",
  },
  {
    title: "Company Guarantee",
    description: "of 1-month's rent to cover any damages",
    image: "/path-to-image-4.jpg",
  },
  {
    title: "We Find New Tenants",
    description: "on every renewal & save money on brokerage",
    image: "/path-to-image-5.jpg",
  },
  {
    title: "Normal Rent Agreement",
    description: "No master-lease/Sub-lease",
    image: "/path-to-image-6.jpg",
  },
  {
    title: "Move In & Move Out Report",
    description: "along with deep cleaning & full management",
    image: "/path-to-image-7.jpg",
  },
];

const tenantBenefits = [
  {
    title: "ZERO Security Deposit",
    description:
      "We trust our members to not damage the house or vacate during the lock-in period.",
    image: "/path-to-image-1.jpg",
  },
  {
    title: "ZERO Membership Charges",
    description:
      "You pay the same rent agreed with your landlord simply as a No-Cost EMI. Deducted monthly just like your Netflix subscription.",
    image: "/path-to-image-2.jpg",
  },
];

// const NewBenefits = () => {
//   const navigate = useNavigate();

//   const [selectedTab, setSelectedTab] = useState("tenant");
//   const benefits = selectedTab === "tenant" ? tenantBenefits : landlordBenefits;
//   const [touchStartX, setTouchStartX] = useState(null);
//   const [touchEndX, setTouchEndX] = useState(null);

//   const minSwipeDistance = 50;

//   const onTouchStart = (e) => {
//     setTouchEndX(null);
//     setTouchStartX(e.targetTouches[0].clientX);
//   };

//   const onTouchMove = (e) => {
//     setTouchEndX(e.targetTouches[0].clientX);
//   };

//   const onTouchEnd = () => {
//     if (!touchStartX || !touchEndX) return;

//     const distanceX = touchStartX - touchEndX;
//     const isLeftSwipe = distanceX > minSwipeDistance;
//     const isRightSwipe = distanceX < -minSwipeDistance;

//     if (isLeftSwipe) setSelectedTab("landlord");
//     if (isRightSwipe) setSelectedTab("tenant");
//   };

//   const handleNext = () => {
//     navigate("/sign-up");
//   };

//   return (
//     <Div100vh
//       className="flex flex-col bg-[#010101] bg-no-repeat bg-cover justify-between py-4"
//       style={{
//         backgroundImage: `linear-gradient(to bottom, rgba(1, 1, 1, 1) 10%, rgba(1, 1, 1, 1) 0% ,rgba(1, 1, 1, 0) 100%), url(${bgBhai})`,
//       }}
//       onTouchStart={onTouchStart}
//       onTouchMove={onTouchMove}
//       onTouchEnd={onTouchEnd}
//     >
//       <div className="px-6 flex flex-col gap-3">
//         <span className="text-xl sm:text-2xl font-medium">CLUB Benefits</span>
//         <div className="flex justify-between my-2 sm:mx-6">
//           <button
//             onClick={() => setSelectedTab("tenant")}
//             className={`text-xs min-w-max px-4 py-2 ${selectedTab === "tenant" ? "text-white border-b-2 border-white" : "text-gray-400"}`}
//           >
//             Tenant Benefits
//           </button>
//           <button
//             onClick={() => setSelectedTab("landlord")}
//             className={`text-xs min-w-max px-4 py-2 ${selectedTab === "landlord" ? "text-white border-b-2 border-white" : "text-gray-400"}`}
//           >
//             Landlord Benefits
//           </button>
//         </div>
//         <div className="flex flex-col gap-2 overflow-y-scroll">
//           {benefits.map((benefit, index) => (
//             <div
//               key={index}
//               className="flex flex-col bg-[#444] bg-opacity-30 px-6 p-3 rounded-lg backdrop-blur-2xl border border-[#888]/50"
//             >
//               <div className="gap-2 flex flex-col">
//                 <h2 className="text-xs sm:text-sm font-medium">
//                   {benefit.title}
//                 </h2>
//                 <p className="text-xs font-light sm:text-normal text-gray-300">
//                   {benefit.description}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className="px-10" onClick={() => handleNext()}>
//         <PrimaryButton text="Next" />
//       </div>
//     </Div100vh>
//   );
// };

// export default NewBenefits;

export default function NewBenefits() {
  const navigate = useNavigate();

  const benefits = [
    "Advance Rent of 9 months",
    "Company Guarantee to cover any potential damages",
    "New tenants on every renewal",
  ];

  const handleNext = () => {
    trackBtnClick("Next", "Benefits Screen");
    navigate("/sign-up");
    return;
  };

  return (
    <Div100vh
      className="flex flex-col bg-[#010101] bg-no-repeat bg-cover justify-between py-4 px-8"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(1, 1, 1, 1) 10%, rgba(1, 1, 1, 1) 0% ,rgba(1, 1, 1, 0) 100%), url(${bgBhai})`,
      }}
    >
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <Header heading="How Zero Security Deposit Works ?" />
          <span className="w-full text-xs text-[#999999]">
            Simply find your new home & connect us with your Landlord
          </span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="w-full text-xs">
            CirclePe Club gives your new landlord
          </span>
          <div className="flex flex-col gap-4">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex flex-col bg-[#444] justify-center bg-opacity-30 h-16 px-6 p-3 rounded-lg backdrop-blur-2xl border border-[#888]/50"
              >
                <div className="gap-2 flex">
                  <p className="text-sm font-light sm:text-normal text-gray-300">
                    {index + 1}.
                  </p>
                  <p className="text-sm font-light sm:text-normal text-gray-300">
                    {benefit}
                  </p>
                </div>
              </div>
            ))}
            <span className="w-full text-center text-2xs">& much more...</span>
          </div>
        </div>
      </div>
      

      <div>
        <PrimaryButton text="Next" handleClick={() => handleNext()}/>
      </div>
    </Div100vh>
  );
}
